// extracted by mini-css-extract-plugin
export default {"container":"Quote_container__eesd0","p":"Quote_p__m2mvn"};